import UserInfo from "./UserInfo.presenter";
export default UserInfo;
